import { getLogger } from '@nerdwallet/logging';
import { isAnyMobileDevice } from "../../utils/user-agent";
var logger = getLogger('web-apple-sdk');
var POPUP_WIDTH = 700;
var POPUP_HEIGHT = 700;

var getWindowFeatures = function getWindowFeatures() {
  // on mobile popup should be full screen
  if (isAnyMobileDevice) return '';
  return ["height=".concat(POPUP_HEIGHT), "width=".concat(POPUP_WIDTH), "top=".concat(Math.floor((window.screen.height - POPUP_HEIGHT) / 2)), "left=".concat(Math.floor((window.screen.width - POPUP_WIDTH) / 2))].join(', ');
};
/**
 * @param {string} state - Arbitrary string value that will be passed as state param to Apple Sign in
 *
 * @return {Window|null} Reference to the Apple Sign-in window, or null if the window couldn't be opened
 */


export var openPopup = function openPopup(state) {
  var popup = window.open("/home/apple-signin/interstitial.html?state=".concat(state), 'appleAuthPopup', getWindowFeatures());

  if (!popup) {
    logger.error('Failed to open popup window');
  }

  return popup;
};